module.exports = __webpack_public_path__ + "media/smiles/sad_2-7fd29bc8.svg";